import { Component } from 'react';
import { esErrorDeCargaDeModulo, recargarUnaVez } from '../utils/actualizacionApp';

// Si una pantalla no carga (por ejemplo, su archivo cambió con un deploy), en vez de
// dejar la app en blanco ofrece recargar; si es un archivo viejo, recarga sola una vez.
export default class ErrorCarga extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (esErrorDeCargaDeModulo(error)) recargarUnaVez();
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-base-200 p-6 text-center">
        <p className="text-base font-semibold">No se pudo abrir esta pantalla.</p>
        <p className="text-sm text-base-content/70">Puede haber una versión nueva de la app o un problema de conexión.</p>
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Recargar</button>
      </div>
    );
  }
}
